export const API_URLS = {
  AUTH: {
    USER_LOGIN: "/login/",
    USER_REGISTER: "/register/",
    USER_LOGOUT: "/logout/",
    ACCEPT_INVITE: "/user/invite/",
    VALIDATE_INVITE: "/user/invite/",
    RESET_PASSWORD: "/reset-password/",
    PASSWORD_RESET_REQUEST: "/auth/password-reset/",
    GOOGLE_LOGIN: "oauth/google-dashboard/",
    LINKEDIN_LOGIN: "oauth/linkedin-dashboard/",
    FORGET_PASSWORD: "forgot-password/",
  },
  PROFILE: {
    UPDATE_PROFILE: "/user/update/",
    GET_PROFILE_DATA: "/user/",
    CUSTOMER_BOOKING_POLICY_UPDATE: "/bookings/settings/update/",
    ADMIN_BOOKING_POLICY_UPDATE: "/bookings/admin/settings/update/",
    GET_ADMIN_BOOKING_POLICY: "/bookings/admin/settings/list",
    GET_EMPLOYEE_BOOKING_POLICY: "/bookings/employee/settings/list",
    EMPLOYEE_BOOKING_POLICY_UPDATE: "/bookings/employee/settings/update/",
    GET_CUSTOMER_BOOKING_POLICY: "/bookings/settings/list",
    UPDATE_PROFILE_LOGO: "/user/upload-logo/",
    INVITE_USER: "/user/invite/",
    CREATE_USER: "/users/",
  },
  CUSTOMER: {
    GET_CUSTOMER_BY_ID: "/customers",
    ADD_CUSTOMER: "/customers",
    UPDATE_CUSTOMER: "/customers",
    GET_CUSTOMER: "/customers/list",
    DELETE_CUSTOMER: "/customers/delete",
    ARCHIVE_CUSTOMER: "/customers/archive",
    ACTIVATE_CUSTOMER: "/customers/activate",
    DEACTIVATE_CUSTOMER: "/customers/deactivate",
    EXPORT_CUSTOMER: "/customers/export/",
    GET_CUSTOMER_STATS: "/customers/statistics",
    RESET_PASSWORD: "/customers/reset-password",
  },
  TEE_AGENT: {
    CHAT: "/tee-agent/chat/",
    SESSIONS: "/tee-agent/sessions/",
    SESSION_DETAIL: "/tee-agent/sessions",
    EXECUTE_ACTION: "/tee-agent/actions/execute/",
    CAPABILITIES: "/tee-agent/capabilities/",
  },
  OPERATIONS_HOURS: { GET_OPERATIONS_HOURS: "/bookings/business-hours" },

  PRICING_HOURS: {
    GET_PRICING_HOURS: "/bookings/business-hours/prices",
    UPDATE_PRICING_HOURS: "/bookings/business-hours/update-price/",
    PRICING_HOURS_TEMPLATE: "/bookings/business-hours/templates/",
    SIMULATOR_PRICING_HOURS: "/bookings/business-and-simulator-hours/prices/",
    UPDATE_SIMULATOR_PRICING_HOURS:
      "/bookings/business-and-simulator-hours/update-price/",
  },

  BUSSINESS_HOURS: {
    GET_BUSSINESS_HOURS: "/bookings/business-hours",
    UPDATE_BUSSINESS_HOURS: "/bookings/business-hours/update/",
    SPECIAL_DAYS: "/bookings/business-holidays/",
    SPECIAL_DAYS_PRICING: "/bookings/business-holidays/prices/",
  },
  PAYMENT_GATEAWAYS: {
    PAYMENT_GATEAWAYS: "/payment-gateways/",
  },

  BOOKINGS: {
    GET_BOOKING_STATS: "/bookings/statistics",
    GET_BOOKING_HISTORY: "/bookings/",
    CHECK_BOOKINGS: "/bookings/check",
    CREATE_BOOKINGS: "/bookings/",
    GET_BOOKINGS: "/bookings",
    GET_Monthly_BOOKINGS: "/bookings/calendar-view-month-wise",
    CANCEL_BOOKINGS: "/bookings/cancel/",
    CANCEL_BOOKING_BY_ID: "/bookings/{id}/cancel/",
    BOOKINGS_DELETE: "/bookings/delete/",
    GET_CALENDAR_BOOKINGS: "/bookings/calendar-view",
    GET_CALENDAR_VIEW: "/bookings/update-booking-view",
    GET_BOOKINGS_COUNT: "/bookings/count",
    UPDATE_BOOKING: "/bookings/",
    QUICK_BOOKING: "/bookings/quick-booking/",
    EXPORT_BOOKINGS: "/bookings/export/",
    TIMESLOT_PRICING: "/bookings/timeslots",
    BAYS: "/bookings/bays/",
    BLOCK_HOURS: "/bookings/bays/blocked-hours/",
    BLOCK_BAY: "/bookings/bays/blocked-days/",
    BOOKING_AUTO_RESOLVE: "bookings/auto-reassign-booking-bay/",
    EVENT_AUTO_RESOLVE: "bookings/auto-reassign-event-bay/",
    BULK_UNBLOCK_BAY: "/bookings/bays/blocked-hours/bulk-unblock/",
    BLOCK_BAY_INDEFINITELY: "/bookings/bays/indefinite-block/",
    PENDING_TIMER: "/bookings/",
    TRANSFER_PREVIEW: "/bookings/{id}/transfer-preview/",
    TRANSFER_CUSTOMER: "/bookings/{id}/transfer-customer/",
  },
  WAITLIST: {
    GET_WAITLIST_LIST: "/waitlist/",
    GET_WAITLIST_ENTRY: "/waitlist/", // + {id}/
    CREATE_WAITLIST: "/waitlist/",
    UPDATE_WAITLIST: "/waitlist/", // + {id}/
    DELETE_WAITLIST: "/waitlist/", // + {id}/
    REORDER_WAITLIST: "/waitlist/reorder/",
    GET_WAITLIST_STATS: "/waitlist/statistics/",
    EXPORT_WAITLIST: "/waitlist/export/",
    GET_WAITLIST_ACTIVITY: "/waitlist/", // + {id}/activity/
  },


  EVENTS: {
    GET_EVENTS_LIST: "/events",
    GET_EVENT_BY_ID: "/events/",
    CHECK_BAYS: "/events/check-available-bays/",
    GET_CALENDAR_EVENTS: "/events/calendar/",
    CREATE_EVENT: "/events/",
    REGISTER_EVENT: "/events/register/",
    CANCEL_EVENT: "/events/cancel/",
    UPDATE_EVENT: "/events/",
    GET_CATEGORIES: "/events/category/",
    EVENT_CATEGORIES: "/events/category/",
    EXPORT_EVENTS_DATA: "/events/export/",
    GET_EVENT_STATS: "/events/statistics",
    NOTIFY_CUSTOMER: "/events/notify-customer/",
    GET_EVENT_TYPES: "/events/types/",
    EXPORT_EVENT_CONTACTS: "/events/contacts-export/",
  },
  NOTIFICATIONS: {
    GET_LATEST_NOTIFICATIONS: "/notifications/",
    DELETE_NOTIFICATIONS: "/notifications/delete",
    MARK_NOTIFICATIONS: "/notifications/mark-viewed",
    // Notification Groups (Admin)
    NOTIFICATION_GROUPS: "/notification-groups/",
    NOTIFICATION_GROUP_DETAIL: "/notification-groups/", // + {id}/
    NOTIFICATION_GROUP_MEMBERS: "/notification-groups/", // + {id}/members/
    NOTIFICATION_GROUP_ADD_MEMBERS: "/notification-groups/", // + {id}/members/add/
    NOTIFICATION_GROUP_REMOVE_MEMBERS: "/notification-groups/", // + {id}/members/remove/
    NOTIFICATION_GROUP_STATS: "/notification-groups/stats/",
    NOTIFICATION_GROUP_AVAILABLE: "/notification-groups/available/",
    NOTIFICATION_GROUP_SYNC: "/notification-groups/sync/",
    // User Notification Groups
    USER_NOTIFICATION_GROUPS: "/user-notification-groups/my-groups/",
    USER_NOTIFICATION_PREFERENCES: "/user-notification-groups/", // + {group_id}/preferences/
  },
  MEMBERSHIP: {
    CREATE_MEMBERSHIP: "/membership-plans/",
    GET_MEMBERSHIP_PLANS: "/membership-plans/",
    UPDATE_MEMBERSHIP: "/membership-plans/",
    EDIT_MEMBERS_LIST: "/customers/list",
    UPDATE_MEMBERS: "/customers/update-membership/",
    CANCEL_MEMBERSHIP: "/membership-plans/",
    CANCEL_MEMBERSHIP_BY_ID: "/memberships/{id}/cancel/",
    DELETE_MEMBERSHIP: "/membership-plans/",
    UPDATE_USER_MEMBERSHIP: "/user-membership-plans/",
    CREATE_USER_MEMBERSHIP: "/user-membership-plans/",
    GET_USER_MEMBERSHIP: "/user-membership-plans/",
    GET_MEMBERSHIP_STATS: "/memberships/statistics/",
    // Season Hours Management
    GET_SEASON_HOURS: (planId: number) => `/membership-plans/${planId}/season-hours/`,
    UPDATE_SEASON_HOURS: (planId: number) => `/membership-plans/${planId}/season-hours/`,
  },
  TRANSACTIONS: {
    GET_TRANSACTIONS: "/transactions/",
    EXPORT_TRANSACTIONS: "/transactions/export/",
    GET_TRANSACTION_NOTES: "/transactions/notes/",
    CREATE_TRANSACTION_NOTE: "/transactions/notes/",
    UPDATE_TRANSACTION_NOTE: "/transactions/notes/",
    DELETE_TRANSACTION_NOTE: "/transactions/notes/",
    GET_TRANSACTION_RECEIPT: "/retrieve-clover-transaction-receipt",
    TRANSACTION_REFUND: "/refund/",
    GET_TRANSACTION_STATS: "/transactions/statistics",
    NOTIFY_TRANSACTION: "/transactions/notify/",
  },
  VENUE: {
    GET_VENUE_SETTINGS: "/bookings/venue/settings/",
    CREATE_VENUE_SETTINGS: "/bookings/venue/settings/",
    UPDATE_VENUE_SETTINGS: "/bookings/venue/settings/",
  },

  LANGUAGE_REGION: {
    CREATE_LANGUAGE_SETTINGS: "/bookings/regional-date/settings/",
    UPDATE_LANGUAGE_SETTINGS: "/bookings/regional-date/settings/",
    GET_LANGUAGE_SETTINGS: "/bookings/regional-date/settings/",
  },
  SUBSCRIBERS: {
    GET_SUBSCRIBERS: "/events/subscribers/",
    CREATE_SUBSCRIBERS: "/events/subscribers/",
    UPDATE_SUBSCRIBERS: "/events/subscribers/",
    DELETE_SUBSCRIBERS: "/events/subscribers/",
  },

  MANAGE_USERS: {
    ADD_USER: "/user/admin-users/",
    UPDATE_USER: "/user/admin-users/",
    DELETE_USER: "/user/admin-users/",
    DOWNGRADE_USER: "/user/admin-users/", // + {id}/downgrade-to-customer/
    GET_USERS: "/user/admin-users/",
    GET_ROLES: "/user/roles/",
    ASSIGN_ROLES: "/user/assign-roles/",
    GROUPED_PERMISSIONS: "/group-permissions/",
    ASSIGN_PERMISSIONS: "/user-permissions/",
    USER_PERMISSIONS: "/user-permissions/",
    // Custom Permission System
    GET_ALL_PERMISSIONS: "/user/permissions/",
    GET_USER_WITH_PERMISSIONS: "/user/admin-users/",
    ASSIGN_USER_PERMISSIONS: "/user/users/",
    // Role-Based System (NEW)
    GET_ROLE_TEMPLATES: "/user/role-templates/",
    GET_ROLE_TEMPLATE_DETAILS: "/user/role-templates/", // + {id}/
    ASSIGN_ROLE_TO_USER: "/user/users/", // + {userId}/role/
    // Permission Groups API (NEW)
    GET_PERMISSION_GROUPS: "/user/permission-groups/",
    GET_ROLE_PERMISSION_GROUPS: "/user/roles/", // + {roleId}/permission-groups/
    UPDATE_ROLE_PERMISSION_GROUPS: "/user/roles/", // + {roleId}/permission-groups/update/
    GET_PERMISSION_GROUP_STATS: "/user/permission-groups/stats/",
    // User Permission Groups API (NEW)
    GET_USER_PERMISSION_GROUPS: "/user/users/", // + {userId}/permission-groups/
    GET_USER_DIRECT_PERMISSION_GROUPS: "/user/users/", // + {userId}/direct-permission-groups/
    UPDATE_USER_PERMISSION_GROUPS: "/user/users/", // + {userId}/permission-groups/update/
  },

  NEWSLETTER: {
    GET_NEWSLETTER: "/subscriptions/newsletter-subscribers",
    DELETE_NEWSLETTER: "/subscriptions/newsletter-subscribers/",
  },

  SUBMISSIONS: {
    CONTACT_FORMS: "subscriptions/contact-forms/",
    EXPORT_CONTACT: "subscriptions/contact-forms/export/",
    EXPORT_NEWSLETTER: "subscriptions/newsletter-subscribers/export/",
    EXPORT_LEAGUES: "subscriptions/league-contact-forms/export/",
    EXPORT_EVENTS: "subscriptions/event-contact-forms/export/",
    LEAGUES: "subscriptions/league-contact-forms/",
    GET_SUBSCRIPTION_STATS: "/subscriptions/statistics/",
    EVENTS: "subscriptions/event-contact-forms/",
  },

  SETTINGS: {
    COUNTRIES: "/settings/countries/",
    STATES: "/settings/states/",
    CITIES: "/settings/cities/",
    TIMEZONES: "/settings/timezones/",
    DATE_FORMATS: "/settings/date-formats/",
    NOTIFICATION_SETTING: "/settings/notifications/",
    SEASONS: "/settings/seasons/",
    SEASONS_VALIDATE_CONTINUITY: "/settings/seasons/validate-continuity/",
    SEASONS_PRICING_MATRIX_PREVIEW: (seasonId: number) =>
      `/settings/seasons/${seasonId}/bays/pricing-matrix/preview/`,
    PRICING_FORMAT: "/settings/pricing-format/",
    SEASON_BUSINESS_HOURS: (seasonId: number) => `/settings/seasons/${seasonId}/hours/`,
    SEASON_BUSINESS_HOURS_DETAIL: (seasonId: number, hoursId: number) => `/settings/seasons/${seasonId}/hours/${hoursId}/`,
    OPERATION_HOURS_DETAIL: (rangeId: number) => `/settings/operation-hours/hours/${rangeId}/`, // Deprecated: use SEASON_BUSINESS_HOURS_DETAIL
    OPERATION_HOURS_WITH_PRICING: "/settings/operation-hours/",
    ADJUSTMENT_TEMPLATE_AVERAGE: "/settings/operation-hours/adjustment-template-average/",
    BAY_HOVER_PRICING: "/settings/seasons/bay-hover-pricing/",
  },

  SPECIAL_DATES: {
    AUTO_DETECT_SEASON: "/seasons/special-dates/auto-detect/",
    GET_SPECIAL_DATES: (seasonId: number) => `/seasons/${seasonId}/special-dates/`,
    CREATE_SPECIAL_DATE: (seasonId: number) => `/seasons/${seasonId}/special-dates/`,
    SPECIAL_DATE_DETAIL: (seasonId: number, specialDateId: number) =>
      `/seasons/${seasonId}/special-dates/${specialDateId}/`,
    COPY_FROM_DATE: (seasonId: number, specialDateId: number) =>
      `/seasons/${seasonId}/special-dates/${specialDateId}/copy-from/`,
  },

  DYNAMIC_PRICING: {
    SEASON_CONFIG: (seasonId: number) => `/settings/seasons/${seasonId}/dynamic-pricing/`,
    WEATHER_CURRENT: "/settings/weather/current/",
    WEATHER_FORECAST: "/settings/weather/forecast/",  // Will be implemented in backend
    DEMAND_PATTERNS: "/settings/demand/patterns/",    // Will be implemented in backend
    DEMAND_HEATMAP: "/settings/demand/heatmap/",
    PRICING_HISTORY: "/settings/dynamic-pricing/history/",
    PRICING_CURRENT_ADJUSTMENTS: "/settings/pricing/current-adjustments/", // Will be implemented
    PRICING_RECALCULATE: "/settings/pricing/recalculate/", // Will be implemented
    DASHBOARD_STATS: "/settings/dashboard/dynamic-pricing/stats/", // Will be implemented
  },

  ANALYTICS: {
    KPI: "v1/analytics/kpis/",
    DAILY_TRENDS: "v1/booking-analytics/daily-trends/",
    HOURLY_HEATMAP: "v1/analytics/hourly-booking-heatmap/",
    BAY_UTILIZATION: "v1/analytics/bay-utilization/",
    SESSION_DURATION: "v1/analytics/session-duration/",
    CUSTOMER_SEGMENTATION: "v1/analytics/customer-segmentation/",
    TOP_CUSTOMERS: "v1/analytics/top-customers/",
    PAYMENT_PERFORMANCE: "v1/analytics/payment-performance/",
    SCHEDULED_REPORTS: "v1/analytics/scheduled-reports/",
    SCHEDULED_REPORT_DETAIL: (id: number) => `v1/analytics/scheduled-reports/${id}/`,
    ADD_RECIPIENT: (id: number) => `v1/analytics/scheduled-reports/${id}/recipients/add/`,
    BULK_ADD_RECIPIENTS: (id: number) => `v1/analytics/scheduled-reports/${id}/recipients/bulk-add/`,
    IMPORT_CSV_RECIPIENTS: (id: number) => `v1/analytics/scheduled-reports/${id}/recipients/import-csv/`,
    REMOVE_RECIPIENT: (id: number, recipientId: number) => `v1/analytics/scheduled-reports/${id}/recipients/${recipientId}/`,
    GET_RECIPIENTS: (id: number) => `v1/analytics/scheduled-reports/${id}/recipients/`,
    REPORT_HISTORY: (id: number) => `v1/analytics/scheduled-reports/${id}/history/`,
    GENERATE_REPORT: (id: number) => `v1/analytics/scheduled-reports/${id}/generate/`,
  },

  LESSONS: {
    COACHES: "/coaches/",
    WEEKLY_HOURS: "/coaches-weekly-hours/",
    SPECIFIC_DATES: "/coaches-calendar-days",
    COACH_SIMULATOR_DISCOUNT: "/coaches/prices/simulator-discount/",
    COACH_PRICES: "/coaches/prices/",
    CHECK_AVAILABILITY: "/coaches/availability/check/",
    CREATE_LESSON_BOOKING: "/lessons/bookings/",
  },

  MEDIA: {
    GET_MEDIA_LIBRARY: "/media-library/",
    UPLOAD_MEDIA: "/media-library/upload/",
  },

  POPUP: {
    // Configuration Management
    GET_POPUPS: "/popup/config/",
    CREATE_POPUP: "/popup/config/",
    GET_POPUP_BY_ID: (id: string) => `/popup/config/${id}/`,
    UPDATE_POPUP: (id: string) => `/popup/config/${id}/`,
    DELETE_POPUP: (id: string) => `/popup/config/${id}/`,
    UPDATE_STATUS: (id: string) => `/popup/config/${id}/status/`,
    DUPLICATE_POPUP: (id: string) => `/popup/config/${id}/duplicate/`,
    // Media Management
    UPLOAD_IMAGE: "/popup/upload/",
    DELETE_IMAGE: (id: string) => `/popup/images/${id}/`,
    // Lead Management
    SUBMIT_FORM: "/popup/submit/",
    GET_LEADS: "/popup/leads/",
    GET_LEAD_BY_ID: (id: string) => `/popup/leads/${id}/`,
    DELETE_LEAD: (id: string) => `/popup/leads/${id}/`,
    EXPORT_LEADS: "/popup/export/",
    // Analytics
    TRACK_EVENT: "/popup/track/",
    GET_ANALYTICS: "/popup/analytics/",
    GET_POPUP_ANALYTICS: (popupId: string) => `/popup/analytics/${popupId}/`,
    GET_AB_ANALYTICS: (groupId: string) => `/popup/analytics/ab-test/${groupId}/`,
    // Widget Delivery
    GET_WIDGET: "/popup/widget.js",
    GET_ACTIVE_POPUPS: "/popup/active/",
  },

  PIN_AUTH: {
    VERIFY_PIN: "/pin-auth/verify/",
    STAFF_LIST: "/pin-auth/staff/",
    STAFF_DETAIL: (id: number) => `/pin-auth/staff/${id}/`,
    RESET_PIN: (id: number) => `/pin-auth/staff/${id}/reset-pin/`,
    VERIFICATION_LOGS: "/pin-auth/logs/",
    USER_PIN: (userId: number) => `/pin-auth/user/${userId}/pin/`,
    CURRENT_USER_STATUS: "/pin-auth/me/status/",
  },

  WEBSITE_VISITORS: "https://plausible.io/api/v2/query",
  BOOKING_ANALYTICS: "/bookings/analytics",
  CONSOLIDATED_CALENDER: "bookings/consolidated/calendar-view-month-wise",

  // Website CMS
  CMS: {
    // Admin endpoints
    GET_CONTENT: "/cms/content/",
    UPDATE_CONTENT: "/cms/content/",
    PUBLISH_CONTENT: "/cms/content/publish/",
    GET_VERSIONS: "/cms/versions/",
    GET_VERSION_DETAIL: (id: number) => `/cms/versions/${id}/`,
    RESTORE_VERSION: (id: number) => `/cms/versions/${id}/restore/`,
    AI_GENERATE: "/cms/ai/generate/",
    // Branding endpoints
    GET_BRANDING: "/settings/branding/",
    UPDATE_BRANDING: "/settings/branding/",
  },
};
